/**
 * MicOffIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const MicOffIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M19.9 9.1a.9.9 0 0 1 .9.9 8.87 8.87 0 0 1-2.607 6.293 8.87 8.87 0 0 1-5.394 2.562v2.487h2.091a.9.9 0 1 1 0 1.8h-6a.9.9 0 0 1 0-1.8H11v-2.487a8.87 8.87 0 0 1-5.393-2.562A8.87 8.87 0 0 1 3 10a.9.9 0 1 1 1.8 0 7.07 7.07 0 0 0 2.08 5.02 7.07 7.07 0 0 0 5.02 2.08 7.07 7.07 0 0 0 5.02-2.08A7.07 7.07 0 0 0 19 10a.9.9 0 0 1 .9-.9m-8-8.1a5 5 0 0 1 5 5v4a5 5 0 0 1-10 0V6a5 5 0 0 1 5-5m0 1.8A3.2 3.2 0 0 0 8.7 6v4a3.2 3.2 0 0 0 6.4 0V6a3.2 3.2 0 0 0-3.2-3.2" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const MicOffIcon = makeIcon('MicOffIcon', MicOffIconSvg)
